import React, { Component } from 'react';
import styled from 'styled-components';
import Icon from '../Icon';
import { Row } from '../Grid';
import Text from '../Text';
import { number, func } from 'prop-types';
import { urlSisa, urlBase } from './../../../components/utils/changeUrlSisa';

let color = '#a4c735';

if (urlSisa() === urlBase()) {
    color = '#4daea9';
}

const NotificationContainer = styled.div`
  position: fixed;
  left: 10px;
  bottom: 10px;
  width: 330px;
  height: 40px;
  border-radius: 4px;
  background-color: ${color};
  display: flex;
  animation: ${({ closedManually }) => closedManually ? 'hideNotification ease-out .5s' : 'showNotification ease-out 7s'};

  @keyframes showNotification {
    0% {
      transform: translateX(-350px);
    }
    5% {
      transform: translateX(0);
    }
    95% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-350px);
    }
  }

  @keyframes hideNotification {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-350px);
    }
  }
`;

const NotificationContentContainer = styled.div`
  padding: 5px 10px;
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;

const CloseNotificationContainer = styled.div`
  width: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SeeNotificationContainer = styled.div`
  width: 99px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SeeButtonContainer = styled.div`
  width: 99px;
  height: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const SeeButtonText = styled.span`
  color: #ffffff;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: bold;
`;

const NotificationDescriptionContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export default class Notification extends Component {
  static propTypes = {
    quantity: number,
    onClickSee: func,
    onClose: func
  }
  static defaultProps = {
    quantity: 0,
    onClickSee: () => {},
    onClose: () => {}
  }
  state = {
    closedManually: false
  }
  render () {
    const { quantity, onClickSee, onClose } = this.props;
    const { closedManually } = this.state;

    return (
        <NotificationContainer closedManually={closedManually}>
            <NotificationContentContainer>
                <NotificationDescriptionContainer>
                    <Row align='center'>
                        <Text text='Hay' size={12} color='#ffffff' />
                        <Text text={quantity} size={13} color='#ffffff' strong style={{ margin: '0 3px' }} />
                        <Text text='pedidos en espera.' size={12} color='#ffffff' />
                    </Row>
                </NotificationDescriptionContainer>
                <SeeNotificationContainer>
                    <SeeButtonContainer onClick={onClickSee}>
                        <SeeButtonText>ver pedidos</SeeButtonText>
                    </SeeButtonContainer>
                </SeeNotificationContainer>
                <CloseNotificationContainer>
                    <Icon name='cross' color='#ffffff' size={10} pointer onClick={() => {
                    this.setState({ closedManually: true }, () => setTimeout(() => {
                        this.setState({ closedManually: false });
                        onClose();
                    }, 400));
                    }} />
                </CloseNotificationContainer>
            </NotificationContentContainer>
        </NotificationContainer>
    );
  }
};
